module.exports = __webpack_public_path__ + "static/media/HudsonRiverPkLogo.94632fa9.png";